module.exports = __webpack_public_path__ + "img/image1.de38f6f0.jpg";